<template>
<div>  
  <div id="container-map" class="map"></div>
  <div id="map-home-legend" class="map--legend">
      <div class="map--legend-item">  
          <Svg className="map--legend-svg" icon="localisation"/>
          Distance between your pointer and the nearest point of the trail
      </div>
      <div class="map--legend-item">
          <div class="map--legend-coord">Latitude : <span id="span-map-lat"> {{filter.lat}}</span></div> 
          <div class="map--legend-coord">Longitude : <span id="span-map-lon"> {{filter.lon}}</span></div>
      </div>
  </div>
</div>

</template>

<script>
import Svg from './utils/Svg';

import L from 'leaflet';
import { onMounted, ref } from 'vue';

import {mapCreator} from '../composables/map';

export default {
  props:['filters'],
  components: {
    Svg
  },
  setup(props, {emit}){
    const filter = ref(props.filters);

    onMounted( () => {
      const map = mapCreator.createMap(filter.value.lat, filter.value.lon);
      let marker = mapCreator.createMarker(map, filter.value.lat, filter.value.lon)

      map.on("click", function (e) {
        filter.value.lat = e.latlng.lat.toFixed(8);
        filter.value.lon = e.latlng.lng.toFixed(8);

        if (marker) map.removeLayer(marker);
      
        marker = mapCreator.createMarker(map,  filter.value.lat, filter.value.lon);
        map.setView([ filter.value.lat, filter.value.lon]);

        emit('updateFilter', filter.value);
      });
      }
    )
    return{
      filter
    }
  },
  emits: ['updateFilter']
}
</script>

<style lang="scss">
@import '../style/main';
@import '../style/components/map.scss';

</style>
